import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || (import.meta.env.DEV ? 'http://localhost:5000' : window.location.origin)

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('ttaechang_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized
      console.log('401 인증 오류 발생:', error.config?.url)

      // YouTube 검색 API는 인증 없이도 작동해야 하므로 로그아웃 처리 안 함
      if (error.config?.url?.includes('/youtube/search')) {
        console.log('YouTube 검색 API 401 에러 - 로그아웃 처리 안 함')
        return Promise.reject(error)
      }

      // 세션 만료 코드 확인
      const errorCode = error.response?.data?.code
      const errorMessage = error.response?.data?.message || '인증이 필요합니다.'

      // 게스트 모드인지 확인
      const authData = localStorage.getItem('ttaechang_auth')
      let isGuestMode = false
      let isLoggedIn = false
      if (authData) {
        try {
          const parsed = JSON.parse(authData)
          isGuestMode = parsed.user?.provider === 'guest'
          isLoggedIn = !!parsed.token
        } catch (e) {
          // JSON 파싱 실패시 게스트 모드 아님
        }
      }

      // 로그인 상태이고 게스트 모드가 아닐 때만 로그아웃 처리
      if (isLoggedIn && !isGuestMode) {
        // 세션 만료 메시지 표시
        if (errorCode === 'SESSION_EXPIRED') {
          console.log('세션 만료 감지 - 다른 기기에서 로그인됨')

          // 사용자에게 알림 표시 (가능한 경우)
          if (window.showNotification) {
            window.showNotification('다른 기기에서 로그인하여 자동 로그아웃되었습니다.', 'warning')
          } else {
            alert('다른 기기에서 로그인하여 자동 로그아웃되었습니다.')
          }
        }

        // 일반 사용자의 경우 완전한 로그아웃 처리
        console.log('자동 로그아웃 처리 시작...')

        // 전역 이벤트 발생 (authStore에서 감지)
        window.dispatchEvent(new CustomEvent('force-logout', {
          detail: {
            reason: errorCode === 'SESSION_EXPIRED' ? 'session_expired' : 'unauthorized',
            message: errorMessage
          }
        }))

        // 모든 저장된 데이터 완전 삭제
        console.log('저장된 인증 데이터 완전 삭제 시작...')

        // localStorage 완전 정리
        const keysToRemove = [
          'auth_token',
          'ttaechang_auth',
          'ttaechang_token',
          'jwt_token',
          'user_data',
          'refresh_token',
          'oauth_result',
          'oauth_session_conflict'
        ]

        keysToRemove.forEach(key => {
          localStorage.removeItem(key)
          console.log(`localStorage에서 ${key} 제거됨`)
        })

        // sessionStorage 완전 정리
        const sessionKeysToRemove = [
          'oauth_return_url',
          'oauth_provider',
          'oauth_force_login',
          'user_session',
          'temp_auth_data'
        ]

        sessionKeysToRemove.forEach(key => {
          sessionStorage.removeItem(key)
          console.log(`sessionStorage에서 ${key} 제거됨`)
        })

        // axios 인증 헤더 제거
        delete api.defaults.headers.common['Authorization']
        console.log('axios 인증 헤더 제거됨')

        // 기존 auth-logout 이벤트 발생 (이미 잘 작동하고 있음)
        window.dispatchEvent(new CustomEvent('auth-logout'))

        // 브라우저 쿠키 정리 (httpOnly가 아닌 쿠키들)
        document.cookie.split(";").forEach(function(c) {
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        })
        console.log('브라우저 쿠키 정리됨')

        console.log('완전한 로그아웃 처리 완료')

        // 홈으로 리다이렉트
        setTimeout(() => {
          window.location.href = '/'
        }, 100)
      } else {
        // 게스트 모드의 경우 401 오류를 그냥 무시하고 계속 진행
        console.log('게스트 모드 - 401 오류 무시')
      }
    }
    return Promise.reject(error)
  }
)

export default api